"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchTripV2Input = void 0;
const class_validator_1 = require("class-validator");
const interval_input_1 = require("./interval.input");
const pageable_input_1 = require("./generic/pageable.input");
const class_transformer_1 = require("class-transformer");
const near_point_input_1 = require("./near-point.input");
const polygon_validator_1 = require("../../validator/polygon.validator");
class IdFilter {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], IdFilter.prototype, "equals", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], IdFilter.prototype, "in", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], IdFilter.prototype, "notIn", void 0);
class SearchTripV2Input extends pageable_input_1.PageableInput {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => IdFilter),
    __metadata("design:type", IdFilter)
], SearchTripV2Input.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => IdFilter),
    __metadata("design:type", IdFilter)
], SearchTripV2Input.prototype, "department", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SearchTripV2Input.prototype, "accountKey", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], SearchTripV2Input.prototype, "accountKeys", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SearchTripV2Input.prototype, "userTypeKey", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SearchTripV2Input.prototype, "userKey", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], SearchTripV2Input.prototype, "passengerKey", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], SearchTripV2Input.prototype, "passengerEmail", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], SearchTripV2Input.prototype, "passengerFirstName", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], SearchTripV2Input.prototype, "passengerLastName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SearchTripV2Input.prototype, "driverAccountKey", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsIn)(['BERLINE', 'BUSINESS', 'VAN', 'COVTC', 'VAO', 'MOTO', 'GREEN', 'TAXI', 'TAXI_VAN', 'TAXI_CONV', 'ACCESS', 'VAN_ACCESS', 'AMBULANCE', 'UNKNOWN'], {
        each: true,
    }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], SearchTripV2Input.prototype, "panelKey", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsIn)(['INCOMING', 'ONDUTY', 'ONPAYMENT', 'DONE', 'CANCELLED'], {
        each: true,
    }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], SearchTripV2Input.prototype, "state", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsIn)([
        'STANDBY_BEFORE_APPROACH_INCOMING',
        'IN_APPROACH_INCOMING',
        'IN_PLACE_INCOMING',
        'PICKED_UP_STARTED',
        'ADMIN_CANCELLATION',
        'PASSENGER_CANCELLATION',
        'DRIVER_NO_SHOW_CANCELLATION',
        'PASSENGER_NO_SHOW_CANCELLATION',
        'DROPPED_OFF_TERMINATED',
        'WAITING_FOR_PAYEMENT',
    ], {
        each: true,
    }),
    __metadata("design:type", Array)
], SearchTripV2Input.prototype, "subState", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => interval_input_1.IntervalInput),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", interval_input_1.IntervalInput)
], SearchTripV2Input.prototype, "interval", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => interval_input_1.IntervalInput),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", interval_input_1.IntervalInput)
], SearchTripV2Input.prototype, "departureAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => interval_input_1.IntervalInput),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", interval_input_1.IntervalInput)
], SearchTripV2Input.prototype, "bookedAt", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], SearchTripV2Input.prototype, "driverKey", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], SearchTripV2Input.prototype, "riskyArea", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], SearchTripV2Input.prototype, "flash", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => near_point_input_1.NearPointInput),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", near_point_input_1.NearPointInput)
], SearchTripV2Input.prototype, "nearPoint", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SearchTripV2Input.prototype, "packageId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SearchTripV2Input.prototype, "groupId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.Validate)(polygon_validator_1.IsPolygon, { each: true }),
    __metadata("design:type", Array)
], SearchTripV2Input.prototype, "area", void 0);
exports.SearchTripV2Input = SearchTripV2Input;
